<template>
  <div class="pt-3 border rounded border-dark" v-on:click="select"
       v-bind:class="{ selected: item.isSelected, transparent: this.isTransparent }"
       :data-cy="`rating${item.label}`">
        <font-awesome-icon :icon="item.icon" :size="`${item.scale ? item.scale : 3}x`"/>
        <p :style="item.labelStyle">{{ item.label }}</p>
  </div>
</template>

<script>
  export default {
    name: 'SelectionItem',
    props: ['item', 'isTransparent'],
    methods: {
      select() {
        this.$emit('selected', this.item.id);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .selected {
    background-color: hsl(136, 55%, 60%);
    color: white;
  }

  .transparent {
    background: transparent;
  }
</style>
